/**
 * Copy for the end-of-call "Review participants" sheet. Word for word the
 * same as the macOS and Windows sheets — change all three together.
 */
export const PARTICIPANT_REVIEW_COPY = {
  title: 'Review participants',
  subtitle: 'Check who was on this call. Names and roles you change here update the whole call record.',
  roleChangeNote:
    'Changing a role updates every line and alert on this call, removes customer concerns attributed to a salesperson, and re-runs the call analysis.',
  noSalesperson: 'At least one participant must be a salesperson.',
  skip: 'Skip',
  save: 'Save',
  saving: 'Saving…',
} as const;

/** "1 turn" / "N turns". */
export const formatTurns = (turnCount: number): string => (turnCount === 1 ? '1 turn' : `${turnCount} turns`);

/** The participant's (already truncated) first line, in curly quotes. */
export const formatFirstLine = (firstLine: string): string => `\u201C${firstLine}\u201D`;
